import { makeStyles } from '@mui/styles'
import Container from 'components/common/Container'

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Dialog from 'components/custom/dialog/Dialog'
import DialogHead from 'components/custom/dialog/DialogHead'
import DialogFooter from 'components/custom/dialog/DialogFooter'
import Button from 'components/common/Button'

import TextField from 'components/common/text/TextField'

const useStyles = makeStyles({
  dialogBody: {
    padding: '20px',
    display: 'flex',
    gap: '20px 0',
    flexDirection: 'column',
  },
  DialogWidth: {
    width: '450px',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0 10px',
  },
  cancelBtn: {
    width: '77px',
    border: '1px solid #9799B5',
    backgroundColor: 'transparent',
    color: '#4A4D68',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
})

const RecipientDialog = ({ open, onClose }) => {
  const classes = useStyles()
  const [email, setEmail] = useState()

  const handleClick = () => {
    console.log(email)
  }

  return (
    <Container>
      <Dialog open={open} className={classes.DialogWidth}>
        <DialogHead title={'Confirmation'} onClose={onClose} />
        <Container className={classes.dialogBody}>
          <TextField type="email" label="Email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
        </Container>
        <DialogFooter>
          <Container className={classes.dialogFooter}>
            <Button className={classes.cancelBtn} onClick={onClose}>
              Cancel
            </Button>
            <Button width={'92px'} onClick={handleClick}>
              Update
            </Button>
          </Container>
        </DialogFooter>
      </Dialog>
    </Container>
  )
}
export default RecipientDialog
RecipientDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
}
